import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from 'recharts';

const LABELS = {
  demographic: 'Demográfico',
  demand: 'Demanda',
  commercial_intensity: 'Intensidad',
  competition: 'Competencia',
  complementarity: 'Complement.',
  accessibility: 'Accesibilidad',
  dynamism: 'Dinamismo',
  tourism: 'Turismo',
  financial: 'Financiero',
  information_quality: 'Info',
};

export default function IndexRadar({ indices }) {
  const data = Object.entries(LABELS).map(([key, label]) => ({
    subject: label,
    score: indices[key]?.score ?? 0,
    fullMark: 100,
  }));

  return (
    <ResponsiveContainer width="100%" height={340}>
      <RadarChart data={data} cx="50%" cy="50%" outerRadius="75%">
        <PolarGrid stroke="#e2e8f0" />
        <PolarAngleAxis dataKey="subject" tick={{ fontSize: 11, fill: '#475569' }} />
        <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fontSize: 10, fill: '#94a3b8' }} />
        <Radar name="Score" dataKey="score" stroke="#1e3a8a" fill="#1e3a8a" fillOpacity={0.35} />
        <Tooltip />
      </RadarChart>
    </ResponsiveContainer>
  );
}
